import { DETERMINING_INSTALL_MODE_ERROR, FINISH_DETERMINING_INSTALL_MODE } from '../../../actions/Installation/InstallMode/DeterminingInstallMode';
import { foldInstallMode } from '../../../records/InstallMode/InstallMode';
import { mapInstallMode } from '../InstallationUtils';
const determiningInstallModeReducer = (state, action) => {
  switch (action.type) {
    case FINISH_DETERMINING_INSTALL_MODE:
      {
        const retrievalId = action.retrievalId;
        const installMode = action.installMode;
        return mapInstallMode(state, currentInstallMode => foldInstallMode(currentInstallMode)(determining => determining.retrievalId === retrievalId ? installMode : determining, value => value, value => value, value => value, value => value, value => value));
      }
    case DETERMINING_INSTALL_MODE_ERROR:
      {
        const retrievalId = action.retrievalId;
        const error = action.error;
        return mapInstallMode(state, currentInstallMode => foldInstallMode(currentInstallMode)(determining => determining.retrievalId === retrievalId ? determining.set('error', error) : determining, value => value, value => value, value => value, value => value, value => value));
      }
    default:
      // Flow compile-time validation that we've handled every action
      // prettier-ignore
      action;
      return state;
  }
};
export default determiningInstallModeReducer;